import type { ReactNode } from 'react';
import { Box, CloseButton, Group, Text } from '@mantine/core';

interface StatusBannerProps {
  tone: 'success' | 'danger' | 'info';
  message: string;
  icon?: ReactNode;
  onDismiss?: () => void;
}

export const StatusBanner = ({ tone, message, icon, onDismiss }: StatusBannerProps) => (
  <Box
    style={{
      width: '100%',
      padding: 16,
      borderRadius: 12,
      border: `1px solid var(--color-status-${tone})`,
      backgroundColor: `var(--color-status-${tone}-soft)`
    }}
  >
    <Group gap={10} wrap="nowrap" align="flex-start" justify="space-between">
      <Group gap={10} wrap="nowrap" align="flex-start">
        {icon && (
          <Box style={{ color: `var(--color-status-${tone})`, flexShrink: 0, marginTop: 1 }}>
            {icon}
          </Box>
        )}
        <Text fz={13} style={{ color: `var(--color-status-${tone})` }}>
          {message}
        </Text>
      </Group>
      {onDismiss && (
        <CloseButton
          onClick={onDismiss}
          size="sm"
          style={{ color: `var(--color-status-${tone})`, flexShrink: 0 }}
        />
      )}
    </Group>
  </Box>
);
